import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api, fmtTime } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { BigButton } from "@/components/BigButton";
import { DocumentViewer } from "@/components/DocumentViewer";
import { t as tr } from "@/i18n";

export default function Documents() {
  const [trips, setTrips] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/trips").then((r) => setTrips(r.data));
  useEffect(() => {
    load();
  }, []);

  const trip = trips.find((t) => t.id === open?.tripId);
  const updated = (t) => setTrips((all) => all.map((x) => (x.id === t.id ? t : x)));

  return (
    <div className="max-w-6xl mx-auto p-4 lg:p-8">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase">{tr("Archivio documenti")}</h1>
      <p className="text-slate-400 mt-1">{tr("DDT e CMR della merce che trasporti.")}</p>
      <div className="mt-6 space-y-5">
        {trips.map((t) => (
          <section key={t.id} className="nv-card p-5" data-testid={`docs-trip-${t.code}`}>
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <h2 className="font-display text-2xl font-extrabold uppercase">{t.code} · {tr(t.goods.description)}</h2>
                <p className="text-sm text-slate-400">{t.pickup.name} → {t.delivery.name} · {fmtTime(t.pickup.time)}</p>
              </div>
              <StatusBadge status={t.status} />
            </div>
            <div className="grid sm:grid-cols-2 gap-3 mt-4">
              {t.documents.map((d) => (
                <BigButton key={d.type} testId={`docs-open-${t.code}-${d.type}`} icon={FileText} variant="outline" color={d.signed_at ? "#10b981" : "#4accff"}
                  label={tr("Apri {type}", { type: d.type })} sub={`${d.number} · ${tr(d.signed_at ? "firmato" : "da firmare")}`} onClick={() => setOpen({ tripId: t.id, type: d.type })} />
              ))}
            </div>
          </section>
        ))}
      </div>
      <DocumentViewer trip={trip} type={open?.type} onClose={() => setOpen(null)} onSigned={updated} />
    </div>
  );
}
